import { useAppTranslations } from '@treneo/shared/i18n';

import { Box } from '../box';
import { Button, BUTTON_VARIANTS } from '../button';
import { Card } from '../card';
import { CardContent } from '../card-content';
import { Typography } from '../typography';

type Props = Readonly<{
  error: unknown;
  onRetry?: () => void;
}>;

export const QueryErrorDisplay = ({ error, onRetry }: Props) => {
  const { t } = useAppTranslations();

  const errorData =
    'status' in (error as { status?: unknown; data?: unknown })
      ? (error as { data?: unknown }).data
      : null;

  const errorMessage = errorData ? String(errorData) : t('system.unknown');
  const errorText = t(errorMessage) !== errorMessage ? t(errorMessage) : errorMessage;

  return (
    <Box p={3}>
      <Card>
        <CardContent sx={{ textAlign: 'center' }}>
          <Typography color='error' gutterBottom>
            {errorText}
          </Typography>
          {onRetry && (
            <Button onClick={onRetry} variant={BUTTON_VARIANTS.contained}>
              {t('common.retry')}
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};
